import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BrandHeading from "@/components/brand/BrandHeading";
import BrandLabel from "@/components/brand/BrandLabel";
import BrandButton from "@/components/brand/BrandButton";
import { fetchResidences } from "@/lib/api";

const BrionjCollection = () => {
  const [res, setRes] = useState([]);
  useEffect(() => { fetchResidences().then(setRes); }, []);
  return (
    <div className="container-rail py-16 md:py-24" data-testid="brionj-collection-page">
      <BrandLabel withRule>The Collection</BrandLabel>
      <BrandHeading level={1} className="mt-6 max-w-[22ch]">Four residences. Four registers of stillness.</BrandHeading>
      <p className="mt-6 max-w-[60ch] text-[15px] md:text-[16px] text-foreground/75 font-body editorial-measure leading-relaxed">Each residence in the collection is held by a small resident staff and made available by enquiry. Stays are designed; not booked.</p>
      <div className="mt-16 space-y-20 md:space-y-28">
        {res.map((r, i) => (
          <div key={r.id} className="grid md:grid-cols-[1.1fr_1fr] gap-10 items-center">
            <div className="p-6 md:p-8 bg-[hsl(var(--card))] border border-border"><img src={r.hero_image} alt={r.name} className="w-full aspect-[4/3] object-cover" /></div>
            <div>
              <div className="text-[11px] uppercase tracking-[0.42em] text-[hsl(var(--brand-accent))]">{String(i + 1).padStart(2, "0")}. {r.country}</div>
              <Link to={`/brionj/r/${r.id}`} className="mt-4 block font-display italic text-[40px] md:text-[52px] leading-[1.05] text-[hsl(var(--brand-accent))] hover:text-foreground transition-colors" data-testid={`collection-item-${r.id}`}>{r.name}</Link>
              <div className="mt-3 text-[12px] uppercase tracking-[0.3em] text-foreground/60">{r.bedrooms} bedrooms · sleeps {r.sleeps} · {r.indicative_price}</div>
              {r.status === "forthcoming" && <div className="mt-3 inline-block px-2 py-1 text-[10px] uppercase tracking-[0.4em] text-[hsl(var(--brand-accent))] border border-[hsl(var(--brand-accent))]">Forthcoming 2026</div>}
              <p className="mt-6 text-[15px] md:text-[16px] font-body leading-[1.85] text-foreground/85 editorial-measure">{r.description}</p>
              <div className="mt-8 flex gap-4 flex-wrap">
                <BrandButton to={`/brionj/r/${r.id}`} data-testid={`view-${r.id}`}>Discover</BrandButton>
                <BrandButton to={`/brionj/enquire/${r.id}`} variant="ghost" data-testid={`enquire-${r.id}`}>Register interest →</BrandButton>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default BrionjCollection;
